var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"error-messages":_vm.errorMessages,"rows":_vm.rows,"type":_vm.type,"label":_vm.label},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }